import React from "react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { BODY, H3 } from "../../utils/typography";
type ReflectionSectionProps = {
  learned: CaseStudyContent["learned"];
};
export function ReflectionSection({
  learned
}: ReflectionSectionProps) {
  return <CaseStudySection label="What I Learned" data-id="element-144" data-mp="3nqoltrjd7imm">
      <div className="max-w-2xl" data-id="element-145" data-mp="6bhsqb5m52gm">
        <p className={`${H3} text-espresso`} data-id="element-146" data-mp="6aoww586zxd9">{learned.headline}</p>
        <div className={`mt-6 space-y-5 ${BODY} text-espresso/80`} data-id="element-147" data-mp="1cx293g5xx5d">
          {learned.body.map(p => <p key={p} data-id="element-148" data-mp="fcy4onc2tcmy">{p}</p>)}
        </div>
        {learned.closing && <p className={`mt-10 ${H3} text-rust`} data-id="element-149" data-mp="adl5r47xkf40">
            {learned.closing}
          </p>}
      </div>
    </CaseStudySection>;
}